import instanceRequest, {Request} from "../../main/services/Request";
import { PAGINATION_HEADERS } from "../../main/store/constants";

class AlarmService {
    private axiosService: Request;

    public constructor(axiosService: Request) {
        this.axiosService = axiosService;
    }

    public getAlarms(
        page = 1,
        filters = {status: null, locationReferences: [], functionalType: null, types: []},
        sortField = "startAt",
        sortDirection = "desc",
        itemsPerPage:string = "20",
        format= "json",
    ) {

        let types: string[] = [];
        if(filters.types) {
            types = filters.types.map((type: any) => `types[]=${type}`);
        }
        const filtersQuery = this.buildFiltersQuery(filters);
        const body = {locationReference: filters.locationReferences ? filters.locationReferences.map((item: any) => item.id):[]};
        const itemsPerPageQuery = itemsPerPage === 'all' ? `&allItems=1` : `&itemsPerPage=${itemsPerPage}`;

        const query = [];
        query.push(`currentPage=${page}`);
        query.push(itemsPerPageQuery);
        query.push(`sortKey=${sortField}`);
        query.push(`sortDir=${sortDirection}`);
        query.push(`format=${format}`);
        if(filtersQuery.length) {
            query.push(filtersQuery);
        }
        if(types.length) {
            query.push(types.join('&'));
        }
        
        const url = `/api/alarm/list?${query.join('&')}`;

        if (format === "json") {
            return this.axiosService.post(url, body, false).then((response) => {
                return {
                    pagination: this.getPaginationInfo(response.headers),
                    data: response.data,
                };
            });
        } else {
            return this.axiosService.getBlobWithPost(url, body).then((response) => {
                return response;
            });
        }
    }

    public countAlarms(
        filters = {status: null, locationReferences: [], types: []},
    ) {
        let types: string[] = [];
        if(filters.types) {
            types = filters.types.map((type: any) => `types[]=${type}`);
        }

        const filtersQuery = this.buildFiltersQuery(filters);
        const body = {locationReference: filters.locationReferences.map((item: any) => item.id)};

        const query = [];
        if(filtersQuery.length) {
            query.push(filtersQuery);
        }
        if(types.length) {
            query.push(types.join('&'));
        }

        const url = `/api/alarm/count?${query.join('&')}`;
        return this.axiosService.post(url, body, false).then((response) => {
            return {
                count: response.data.count,
            };
        });
    }

    public getPaginationInfo(headers: any): any {
        const pagination: any = [];

        Object.entries(headers).map((header: any) => {
            if (PAGINATION_HEADERS.includes(header[0])) {
                pagination[header[0]] = header[1];
            }
            return pagination;
        });

        return pagination;
    }

    public acknowledgeAlarms(ackUserId: string, ackUserName: string, alarms: string[]) {
        const body = {
            ackUserId,
            ackUserName,
            alarms
        }
        
        const url = `/api/alarm/ack`;
        return this.axiosService.post(url, body, false);
    }

    public updateAlarm(alarmId: string, body = {}) {
        const url = `/api/alarm/${alarmId}`;
        return this.axiosService.put(url, body, false);
    }

    buildFiltersQuery(filters: any) {
        let query: any = [];
        Object.keys(filters).forEach((key) => {
            const value = (filters as any)[key];
            if(key !== 'locationReferences' && key !== 'types' && value !== undefined) {
                query.push(`${key}=${value}`);
            }
        });
        return query.join('&');
    }

    public getAlarmTypes() {
        const url = `/api/alarm-type/list`;
        return this.axiosService.get(url, false, false).then((response) => {
            return {
                data: response.data,
            };
        });
    }
}

export default new AlarmService(instanceRequest);
